import { render, staticRenderFns } from "./events-widget-item.vue?vue&type=template&id=558590eb"
import script from "./events-widget-item.vue?vue&type=script&lang=ts"
export * from "./events-widget-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports